import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
/* actions */
import { getAllCodesNCM, addCodesNCM } from '../../redux/actions/codesNCM';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/codeNCM';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
import handleChangeCurrency from '../../utils/handleChangeCurrency';

function Add (props) {
  const { handleModalClose } = props;
  const INITIAL_VALUES = {
    code: '',
    description: '',
    nacionalAliquot: '0,00',
    importationAliquot: '0,00',
    exTIPI: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema
  });
  const codesNCM = useSelector(state => state.codesNCM);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllCodesNCM());
  }, [dispatch]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    const newData = {
      ...data,
      nacionalAliquot: parseFloat(data.nacionalAliquot.replace(/,/g, '.')),
      importationAliquot: parseFloat(data.importationAliquot.replace(/,/g, '.'))
    };
    dispatch(addCodesNCM(newData, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {codesNCM.addSuccess && (
        <AlertMsg type="success" msg="Código NCM cadastrado com sucesso" />
      )}
      {codesNCM.errorContent &&
        !codesNCM.errorContent.message.includes('400') &&
        codesNCM.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro do código NCM" />
      )}
      {codesNCM.errorContent &&
        codesNCM.errorContent.message.includes('400') &&
        codesNCM.addError && (
        <AlertMsg
          type="danger"
          msg="Um NCM com o código informado já está cadastrado"
        />
      )}
      {!codesNCM.addSuccess && !codesNCM.addError && (
        <AlertMsg type="info" msg="Área cadastro de códigos NCM" />
      )}
      <FormHeader title="Cadastrar Código NCM" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="code">Código</label>
              <InputMask
                id="code"
                name="code"
                mask="9999.99.99"
                className="form-control"
                autoComplete="off"
                placeholder="____.__.__"
                value={data.code}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.code && errors.code.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.code && errors.code.type === 'ncm' && (
                <ErrorMsgField type="ncm" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="nacionalAliquot">Alíquota Nacional</label>
              <input
                type="text"
                className="form-control"
                id="nacionalAliquot"
                name="nacionalAliquot"
                number="on"
                defaultValue={data.nacionalAliquot}
                autoComplete="off"
                onChange={evt => handleChangeCurrency(evt, data, setData)}
                ref={register}
              />
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'currency' && (
                <ErrorMsgField type="currency" />
              )}
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'min' && (
                <ErrorMsgField type="min" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="importationAliquot">Alíquota Importação</label>
              <input
                type="text"
                className="form-control"
                id="importationAliquot"
                name="importationAliquot"
                number="on"
                defaultValue={data.importationAliquot}
                autoComplete="off"
                onChange={evt => handleChangeCurrency(evt, data, setData)}
                ref={register}
              />
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'currency' && (
                <ErrorMsgField type="currency" />
              )}
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'min' && (
                <ErrorMsgField type="min" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="exTIPI">EX-TIPI</label>
              <input
                type="text"
                className="form-control"
                id="exTIPI"
                name="exTIPI"
                autoComplete="off"
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.exTIPI && errors.exTIPI.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">Descrição</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/codes_ncm" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
